<template>
  <div>
    <div class="forgetPsd">
      <div class="checkMethods" v-if="step == 2">
        <div class="checkMethodsCon">
          <div class="checkMethodsOpt">
            <img
              src="../../../../assets/user-img/changeImg/password.svg"
              alt=""
            />
            <span>{{ $fanyi("密码验证") }}</span>
            <el-button
              class="uiBtn uiGreen2"
              @click="
                approveType = 'password';
                next();
              "
            >
              {{ $fanyi("确定") }}
            </el-button>
          </div>
          <div class="checkMethodsOpt">
            <img src="../../../../assets/newImg/mobile.svg" alt="" />
            <span>{{ $fanyi("手机号码") }}</span>
            <el-button
              class="uiBtn uiGreen2"
              @click="
                approveType = 'mobile';
                next();
              "
            >
              {{ $fanyi("确定") }}
            </el-button>
          </div>
          <div class="checkMethodsOpt">
            <img src="../../../../assets/newImg/email.svg" alt="" />
            <span>{{ $fanyi("电子邮箱") }}</span>
            <el-button
              class="uiBtn uiGreen2"
              @click="
                approveType = 'email';
                next();
              "
            >
              {{ $fanyi("确定") }}
            </el-button>
          </div>
        </div>
      </div>
      <div class="changePasswordBox" v-if="step >= 3">
        <nav class="step">
          <div :class="step == 3 ? 'active stepOpt' : 'stepOpt'">
            <label>1</label>
            <span>{{ $fanyi("身份确认") }}</span>
          </div>
          <hr />
          <div :class="step == 4 ? 'active stepOpt' : 'stepOpt'">
            <label>2</label>
            <span
              >{{ changeType == "password" ? $fanyi("登录密码修改") : ""
              }}{{ changeType == "email" ? $fanyi("电子邮箱修改") : ""
              }}{{ changeType == "mobile" ? $fanyi("手机号修改") : "" }}</span
            >
          </div>
          <hr />
          <div :class="step == 5 ? 'active stepOpt' : 'stepOpt'">
            <label>3</label>
            <span class="gengGaiChenGong">{{ $fanyi("更改成功") }}</span>
          </div>
        </nav>
        <StepIdentityConfirm
          v-if="step === 3"
          :approve-type="approveType"
          :change-type="changeType"
          :login-name="login_name"
          @complete="onIdentityStepComplete"
          @reset-methods="qiTaRenZheng"
        />
        <StepUpdateCredential
          v-if="step === 4"
          :change-type="changeType"
          :identity="stepThreeForm"
          :verification-number="onumber"
          :login-name="login_name"
          @complete="onUpdateStepComplete"
        />
        <StepSuccess v-if="step === 5" />
      </div>
    </div>
  </div>
</template>

<script>
import StepIdentityConfirm from "./components/StepIdentityConfirm.vue";
import StepUpdateCredential from "./components/StepUpdateCredential.vue";
import StepSuccess from "./components/StepSuccess.vue";

export default {
  data() {
    return {
      step: 2,
      changeType: this.$route.query.type,
      login_name: this.$store.state.userInfo.login_name,
      approveType: "password",
      stepThreeForm: {
        oldPassword: "",
        regCode: "",
      },
      onumber: "",
    };
  },
  components: {
    StepIdentityConfirm,
    StepUpdateCredential,
    StepSuccess,
  },
  watch: {
    $route: {
      handler() {
        this.step = 2;
        this.changeType = this.$route.query.type;
        this.$forceUpdate();
      },
    },
  },
  computed: {},
  created() {},
  methods: {
    onIdentityStepComplete(payload) {
      Object.assign(this.stepThreeForm, payload);
      this.step++;
    },
    onUpdateStepComplete() {
      this.step++;
    },
    qiTaRenZheng() {
      this.step = 2;
      this.stepThreeForm.oldPassword = "";
      this.stepThreeForm.regCode = "";
      this.onumber = "";
      this.$forceUpdate();
    },
    next() {
      if (this.step !== 2) return;
      this.onumber =
        this.approveType == "mobile"
          ? this.$store.state.userInfo.mobile
          : this.$store.state.userInfo.email;

      this.step++;
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "../../../../css/mixin.scss";
.forgetPsd {
  background: #fafafa;
  > div {
    width: 100%;
    margin: 0 auto;
    height: 442px;
    background: #ffffff;
    border: 1px solid #e1e1e1;
  }

  // 确认认证方式
  .checkMethods {
    position: relative;
    .checkMethodsCon {
      width: 450px;
      margin: 0 auto;
      padding-top: 124px;
      h1 {
        position: absolute;
        font-size: 18px;

        color: #000000;
        line-height: 24px;

        top: 20px;
        left: 20px;
      }
      .checkMethodsOpt {
        height: 68px;
        background: #ffffff;
        border-radius: 16px;
        border: 1px solid #e1e1e1;
        display: flex;
        align-items: center;
        padding: 16px 16px 16px 24px;
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        img {
          width: 24px;
          margin-right: 13px;
        }
        span {
          font-size: 14px;

          color: #000000;
          line-height: 19px;
          margin-right: auto;
        }
        .el-button.uiBtn {
          width: 96px;
          height: 40px;
          font-size: 16px;
          color: #ffffff;
          line-height: 18px;
        }
      }
    }
  }
  // 修改密码
  .changePasswordBox {
    padding-top: 80px;
    .step {
      margin: 0 auto 40px;
      width: 900px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      hr {
        flex: 1;
        height: 1px;
        background: #e1e1e1;
        border: none;
        margin: 0 20px;
      }
      .stepOpt {
        &.active {
          label {
            color: #ffffff;
            background: #009246;
            outline: 6px solid #eaf8e8;
          }
          span {
            color: #009246;
          }
        }
        display: flex;
        align-items: center;
        label {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30px;
          height: 30px;
          color: #000;
          border: 1px solid #888888;
          border-radius: 50%;
          margin-right: 12px;
        }
        span {
          font-size: 16px;

          color: #000;
          line-height: 16px;

          max-width: 200px;
          text-align: center;
        }
      }
    }
    > div {
      width: 900px;
      margin: 0 auto;
    }
  }
}

/deep/.el-form {
  margin: 0 auto;
  width: max-content;
  .el-form-item {
    width: max-content;
  }
  .el-form-item__label {
    padding-right: 11px;
  }
  .el-form-item__content {
    width: max-content;
  }
}

/deep/.nextBtn {
  @extend .uiGreen;
  display: block;
  height: 40px;
  font-size: 16px;
  font-weight: normal;
  padding: 0 16px;
  min-width: 100px;
  margin: 0 auto;
}
</style>
